import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";

/**
 * `agencyImportCommand` is the command used to import an exported folder structure
 * from another archive.
 * `agencyImportCommand` is valid if the current agency have a document archive
 * structure and the current user is backoffice user or it is invoked from the
 * empty archive widget.
 */

/**
 * TODO: write documentation
 */
export default class AgencyImportCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._name = "";
	}

	getName() {
		return this._name;
	}

	setName(newName) {
		this._name = newName;
	}

	accept(aVisitor) {
		return aVisitor.visitAgencyImportCommand(this);
	}

	requireRefresh() {
		return true;
	}

	heading() {
		return getNamedCommandHeading("Administrative");
	}

	priority() {
		return 200;
	}

	uploadPath() {
		return this._documentService.uploadPath();
	}

	_performOnService(callback) {
		this._documentService.executeAgencyImportCommand(this, callback);
	}

	_execute() {}

	static isApplicable(context) {
		return this.shouldShowAdminCommands(context);
	}
}
